import React, { ReactNode, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '@hooks/use-auth-context';

type RedirectCondition = 'noUser' | 'userNotOnboarded' | 'userAuthenticated';

export default function Redirector({
  children,
  redirectOn,
}: {
  children: ReactNode;
  redirectOn: RedirectCondition[];
}) {
  const { user, accountProcessingStatus } = useAuthContext();
  const location = useLocation();
  const navigate = useNavigate();
  const redirectMap = useMemo(
    () =>
      ({
        userAuthenticated: user && '/',
        noUser: !user && '/login',
        userNotOnboarded: user && !user?.has_completed_onboarding && '/onboarding',
      } as Record<RedirectCondition, string | false>),
    [user, accountProcessingStatus],
  );

  useEffect(() => {
    for (const condition of redirectOn) {
      const redirectRoute = redirectMap[condition];
      if (redirectRoute) {
        navigate(redirectRoute, { replace: true });
      }
    }
  }, [location.pathname]);

  return <>{children}</>;
}
